/**
 * The style's pane beside the product list (2026-10-01).
 *
 * The page scrolls as one, and the list can be fifty styles long. The style
 * used to open at the top of the page — above the screen when it was picked
 * far down the list, "it feels like nothing happens", beside a column of
 * white. Now, wide, the pane is pinned under the top bar (products.css), so
 * it is beside whatever row was pressed; stacked on a narrow screen, the page
 * goes to it when it is out of sight.
 *
 * Two rules, kept here so they are tested rather than eyeballed.
 */

/**
 * How tall the pane may be: from where it starts on screen to just above the
 * action bar. Pinned, it starts under the top bar; before the page has
 * scrolled far enough to pin it — always, on a short list — it starts lower,
 * and a fixed height ran its bottom off the screen with the Save bar in it
 * (found driving it, 2026-10-01). Never less than a usable minimum.
 */
export const PANE_MIN_HEIGHT = 240;

export function paneMaxHeight(
  paneTop: number,
  pinnedTop: number,
  visibleBottom: number,
  gap: number,
): number {
  return Math.max(PANE_MIN_HEIGHT, Math.round(visibleBottom - Math.max(paneTop, pinnedTop) - gap));
}

/**
 * Whether picking a style has to bring the pane into view. Wide, the pinned
 * pane starts at the top of what shows, so nothing moves and the place in
 * the list is kept. Stacked on a phone it starts under the list, and only
 * its top edge showing is not enough: the style's buttons wrap above its
 * name, which was still below the screen (found by the browser journey at
 * 390px). In sight means it starts in the upper half of what shows.
 */
export function detailOutOfSight(
  detailTop: number,
  visibleTop: number,
  visibleBottom: number,
): boolean {
  return detailTop < visibleTop || detailTop > visibleTop + (visibleBottom - visibleTop) / 2;
}
